import { PaymentStatuses } from "@app/screens/ConfirmPay/ConfirmPay"
import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import { formatIndianCurrency } from "@app/utils/utility"
import { getPaymentMode } from "../utils"
import LottieView from 'lottie-react-native';
import lottie from "../../../../assets/lottie/succes_tick.json"
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';
import RepayprogresIcon from "../../../../assets/Icons/RepayProgressIcon";
import { DSP_PAYMENT_STATUS } from "@app/utils"

interface UserPaymentData {
    transactionId: string | null;
    pgResponseDetails: {
        bankRefNo: string | null;
        paymentMode: string | null;
    } | null;
    collectionStatus?: string;
}

interface DspPaymentStatusProps {
    dspPaymentStatus: string;
    currentOrderId: string;
    dspAmountCollected: string;
    dspPaymentDate: string;
    failedTitle: string;
    progressTitle: string;
    userPaymentData: UserPaymentData;
}

const DspPaymentStatus: React.FC<DspPaymentStatusProps> = ({dspPaymentStatus, currentOrderId, dspAmountCollected, dspPaymentDate, failedTitle, progressTitle, userPaymentData}) => {
    let label = ''
    const transactionalRefNumber = userPaymentData?.transactionId !== null ? userPaymentData?.transactionId : "Not applicable";
    const bankRefNumber = userPaymentData?.pgResponseDetails !== null && userPaymentData?.pgResponseDetails?.bankRefNo !== null
            ? userPaymentData?.pgResponseDetails?.bankRefNo
            : "Not applicable"
    const paymentMode = 
    userPaymentData?.pgResponseDetails?.paymentMode 
        ? userPaymentData?.pgResponseDetails?.paymentMode === "Unified Payments"
            ? "UPI" 
            : getPaymentMode(userPaymentData?.pgResponseDetails?.paymentMode)
        : "Not applicable"

    let isPaymentSuccess = false;

    if(dspPaymentStatus === '' || dspPaymentStatus === undefined){
        dspPaymentStatus = userPaymentData?.collectionStatus
    }
    let icon = <WarningCircle  size={48} weight="fill" color={themeColorSet["icon-error"]}/>
    if(dspPaymentStatus === DSP_PAYMENT_STATUS.EXEEDED){
        label = 'Maximum attempts exceeded';
        icon = <WarningCircle  size={48} weight="fill" color={themeColorSet["icon-error"]}/>
    }
    else if(dspPaymentStatus === DSP_PAYMENT_STATUS.CANCELLED){
        label = 'Payment cancelled';
        icon = <WarningCircle  size={48} weight="fill" color={themeColorSet["icon-error"]}/>
    }
    else if(dspPaymentStatus === DSP_PAYMENT_STATUS.FAILED){
        label = 'Payment failed';
        icon = <WarningCircle  size={48} weight="fill" color={themeColorSet["icon-error"]}/>
    }
    else if(dspPaymentStatus === DSP_PAYMENT_STATUS.IN_PROGRESS){
        label = 'Payment in progress';
        icon = <RepayprogresIcon />
    } else if(dspPaymentStatus === DSP_PAYMENT_STATUS.SETTLED || dspPaymentStatus === DSP_PAYMENT_STATUS.SUCCESS || dspPaymentStatus === DSP_PAYMENT_STATUS.COLLECTION_COMPLETE){
        label = 'Payment successful'
        isPaymentSuccess = true;
    }

    return (
        <ThemedView style={{marginTop:46}}>
        <ThemedView style={{alignItems:'center'}}>
            {isPaymentSuccess ? <LottieView
                    source={lottie}
                    style={{width: 70, height: 'auto'}}
                    autoPlay={true}
                    loop={true}
                /> : icon}
            <ThemedView mt="lg">
                <ThemedText variant='b2r' color='text-primary' >{label}</ThemedText>
            </ThemedView>
            <ThemedView flexDirection="row" alignItems="center" mt="sm">
                <ThemedText variant="l1" color='text-primary' >₹</ThemedText>
                <ThemedText variant='h1b' color='text-primary' >{formatIndianCurrency(dspAmountCollected)}</ThemedText>
            </ThemedView>
            <ThemedView mt="lg">
                <ThemedText variant='b4r' color='text-secondary' >{dspPaymentDate}</ThemedText>
            </ThemedView>
        </ThemedView>
        {
            (dspPaymentStatus ===   DSP_PAYMENT_STATUS.IN_PROGRESS || dspPaymentStatus === DSP_PAYMENT_STATUS.FAILED) && (
                <ThemedView style={{flexDirection:'row',backgroundColor:'#FEF4E6',paddingHorizontal:16,paddingVertical:8,borderRadius:8}}>
                    <ThemedText>
                        <ThemedText variant='b4s' color='text-primary'>
                          `Note: `
                        </ThemedText>
                        <ThemedText>
                            {dspPaymentStatus ===   DSP_PAYMENT_STATUS.IN_PROGRESS ? progressTitle : failedTitle}
                        </ThemedText>
                    </ThemedText>
               </ThemedView>
            )
        }
        <ThemedView mt="xl" p="lg" borderRadius="sm" style={{backgroundColor: '#F9FAFB', borderWidth: 1, borderColor: '#E4E7EC'}}>
                <ThemedView>
                    <ThemedText variant="b4r" color="text-secondary">
                        Transaction reference number
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {transactionalRefNumber}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>

                <ThemedView mt="lg">
                    <ThemedText variant="b4r" color="text-secondary">
                        Bank reference number
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {bankRefNumber}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>

                <ThemedView mt="lg">
                    <ThemedText variant="b4r" color="text-secondary">
                        Payment Method
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {getPaymentMode(paymentMode)}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
            </ThemedView>
        </ThemedView>
        
    )
}

export default DspPaymentStatus;